import { render, staticRenderFns } from "./EmployeeCustomAttribute.vue?vue&type=template&id=54de6ff6"
import script from "./EmployeeCustomAttribute.vue?vue&type=script&lang=js"
export * from "./EmployeeCustomAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports